DJ.addBehavior('js-select', '.js-select', {
  attach: function(context, settings, behavior) {
    var updatePlaceholder = function (el) {
      var uldiv = el.siblings('span.select2').find('ul')
      var count = el.select2('data').length;
      if (count === 0) {
        uldiv.html(`<div>${placeholder}</div>`)
      } else {
        uldiv.html(`<div>${placeholder} <span class="count">${count}</span></div>`)
      }
    }
    var placeholder = jQuery(this).attr('data-placeholder')
    var select = jQuery('.js-select').select2({
      placeholder: placeholder,
    });
    select.on('select2:change', function () {
      updatePlaceholder(jQuery(this));
    });
    select.on('select2:close', function () {
      updatePlaceholder(jQuery(this));
    });
    select.trigger('select2:change');
  },

  detach: function(context, settings) {}
});
